export const ACTIVITY_CONSTS = {
    GET_NOTIFICATION_ACTIVITY:"GET_NOTIFICATION_ACTIVITY",
    GET_USER_ACTIVITY:"GET_USER_ACTIVITY",
    REMOVE_USER_ACTIVITY:"REMOVE_USER_ACTIVITY",
}
